// Cart events for controls GTM4WP cannot see itself, sent through its own push so the
// dataLayer gets the same shape as its built-in add_to_cart / remove_from_cart.

export function pushCartEvent(event, items) {
    if (!items?.length || typeof window.gtm4wp_push_ecommerce !== 'function') {
        return;
    }

    const value = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    // a top-level const in GTM4WP's inline script, so not on window
    // eslint-disable-next-line no-undef
    const currency = typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : undefined;
    window.gtm4wp_push_ecommerce(event, items, { currency, value: Math.round(value * 100) / 100 });
}
